// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    CATEGORY_VIDEO_LOADING() {
      return {
        isLoading: true,
        categoryVideo: action.categoryVideo
      };
    },
    CATEGORY_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.categoryVideo
      };
    },
    CATEGORY_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
